// test1924
(1924 && 0);
